import { render, staticRenderFns } from "./assessmentnew.vue?vue&type=template&id=0d1b8390"
import script from "./assessmentnew.vue?vue&type=script&lang=js"
export * from "./assessmentnew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports